import * as types from './types';
import Api from '../lib/api';

export function vacanciesPLAction() {
    return async (dispatch, getState) => {
        try{
            let response = await Api.get('Vacancy/PL');
            dispatch(vacancyPLResult(response.data.vacancies ));
            return response.data.vacancies;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function vacancyPLResult(vacancies) {
    return {
        type: types.VACANCY_PL,
        vacancies
    }
}

export function vacancyBySlugAction(slug) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.get('Vacancy/byslug/'+slug);
            dispatch(vacancyBySlugResult( response.data.vacancy ));
            return response.data.vacancy;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function vacancyBySlugResult(vacancy) {
    return {
        type: types.VACANCY_BY_SLUG,
        vacancy
    }
}

export function vacancyPostAction(vacancy) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.post('Vacancy', vacancy, true);
            dispatch(vacancyPostResult(response.state ? true : false ));
            return;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

function vacancyPostResult(vacancyPostState) {
    return {
        type: types.VACANCY_POST,
        vacancyPostState
    }
}

export function vacancyPutAction(vacancy , id) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.put('Vacancy/'+id, vacancy, true);
            dispatch(vacancyPostResult(response.state ? true : false ));
            return;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}

export function vacancyDeleteAction(id) {
    return async (dispatch, getState) => {
        try{
            let response = await Api.delete('Vacancy/'+id);
            dispatch(vacancyPostResult(response.state ? true : false ));
            return;
        }
        catch(err){
            console.error(err);
            return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/actions/vacancy.js